import { PurchaseOrderIntentStatus } from "@/constants/entity-status";
import { AppColors } from "@/styles/colors";
import { Flex, Grid, GridItem, Text } from "@chakra-ui/react";
import { RequestStatusBadge } from "../../badge/RequestStatusBadge";

interface Props {
  titularCuenta?: string;
  cuenta?: number;
  telefono?: string;
  zonaComercial?: string;
  tipoInsumo?: string;
  estadoDescripcion?: string;
}

export const PurchaseOrderIntentMainData = ({
  titularCuenta,
  cuenta,
  telefono,
  zonaComercial,
  tipoInsumo,
  estadoDescripcion,
}: Props) => {
  return (
    <Grid templateColumns="repeat(2, 1fr)" gap={18}>
      <GridItem>
        <Flex
          flexDir="column"
          padding="12px"
          height="100%"
          border={`1px solid ${AppColors.WHITE_BORDER_1}`}
          borderRadius="12px"
        >
          <Text
            className="amd-card-title"
            paddingBottom="10px"
            textTransform="uppercase"
            paddingX="24px"
            fontWeight={700}
          >
            Detalle
          </Text>

          <Grid templateColumns="repeat(2, 1fr)" gridAutoRows="50px">
            <GridItem
              paddingX="24px"
              paddingY="8px"
              backgroundColor={AppColors.BACKGROUND_SECONDARY}
              display="flex"
              alignItems="center"
            >
              <Text className="account-title-label">Cuenta:</Text>
            </GridItem>
            <GridItem
              paddingX="24px"
              paddingY="8px"
              backgroundColor={AppColors.BACKGROUND_SECONDARY}
              display="flex"
              alignItems="center"
            >
              <Text className="account-value-label">
                {titularCuenta && cuenta
                  ? `${titularCuenta} - ${cuenta}`
                  : titularCuenta ?? "-"}
              </Text>
            </GridItem>

            <GridItem paddingX="24px" paddingY="8px" display="flex" alignItems="center">
              <Text className="account-title-label">N° Tel:</Text>
            </GridItem>
            <GridItem paddingX="24px" paddingY="8px" display="flex" alignItems="center">
              <Text className="account-value-label">{telefono ?? "-"}</Text>
            </GridItem>

            <GridItem
              paddingX="24px"
              paddingY="8px"
              backgroundColor={AppColors.BACKGROUND_SECONDARY}
              display="flex"
              alignItems="center"
            >
              <Text className="account-title-label">Zona Comercial:</Text>
            </GridItem>
            <GridItem
              paddingX="24px"
              paddingY="8px"
              backgroundColor={AppColors.BACKGROUND_SECONDARY}
              display="flex"
              alignItems="center"
            >
              <Text className="account-value-label">{zonaComercial ?? "-"}</Text>
            </GridItem>
          </Grid>
        </Flex>
      </GridItem>

      <GridItem>
        <Flex
          flexDir="column"
          padding="12px"
          height="100%"
          border={`1px solid ${AppColors.WHITE_BORDER_1}`}
          borderRadius="12px"
        >
          <Text
            className="amd-card-title"
            paddingBottom="16px"
            textTransform="uppercase"
            paddingX="24px"
            fontWeight={700}
            visibility="hidden"
          >
            -
          </Text>

          <Grid templateColumns="repeat(2, 1fr)" gridAutoRows="50px">
            <GridItem paddingX="24px" paddingY="8px" display="flex" alignItems="center">
              <Text className="account-title-label">Tipo de insumo:</Text>
            </GridItem>
            <GridItem paddingX="24px" paddingY="8px" display="flex" alignItems="center">
              <Text className="account-value-label">{tipoInsumo ?? "-"}</Text>
            </GridItem>

            <GridItem
              paddingX="24px"
              paddingY="8px"
              backgroundColor={AppColors.BACKGROUND_SECONDARY}
              display="flex"
              alignItems="center"
            >
              <Text className="account-title-label">Estado:</Text>
            </GridItem>
            <GridItem
              paddingX="24px"
              paddingY="8px"
              backgroundColor={AppColors.BACKGROUND_SECONDARY}
              display="flex"
              alignItems="center"
            >
              <Text as="span" className="account-value-label">
                <RequestStatusBadge
                  status={estadoDescripcion as unknown as PurchaseOrderIntentStatus}
                />
              </Text>
            </GridItem>
          </Grid>
        </Flex>
      </GridItem>
    </Grid>
  );
};
